var _style, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgZamowienia = function SvgZamowienia(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st14{fill:#ffffff;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M20.8,9.1l-2,11.3H5.3l-2-11.3L1.6,9.4l2.2,11.9C3.9,21.7,4.2,22,4.6,22h14.8c0.4,0,0.7-0.3,0.8-0.7 l2.2-11.9L20.8,9.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M23.2,8.5H0.8C0.4,8.5,0,8.8,0,9.3s0.4,0.8,0.8,0.8h22.4c0.4,0,0.8-0.4,0.8-0.8C24,8.8,23.6,8.5,23.2,8.5z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M20.7,8.8l-4.5-6.5c-0.3-0.4-0.8-0.5-1.1-0.2c-0.4,0.3-0.5,0.8-0.2,1.1l4.5,6.5c0.2,0.2,0.4,0.3,0.7,0.3 c0.2,0,0.3,0,0.5-0.1C20.9,9.7,21,9.2,20.7,8.8z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M9.3,2.1C9,1.9,8.4,2,8.2,2.3L3.7,8.8C3.4,9.2,3.5,9.7,3.9,10c0.1,0.1,0.3,0.1,0.5,0.1 c0.3,0,0.5-0.1,0.7-0.3l4.5-6.5C9.8,2.9,9.7,2.4,9.3,2.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M16.1,12c-0.3-0.3-0.8-0.3-1.1,0l-3.9,3.8l-2-1.9C8.8,13.6,8.3,13.6,8,14c-0.3,0.3-0.3,0.8,0,1.1l2.6,2.4 c0.2,0.1,0.4,0.2,0.5,0.2c0.2,0,0.4-0.1,0.6-0.2l4.4-4.3C16.4,12.8,16.4,12.3,16.1,12z"
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgZamowienia, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/zamowienia.edfd04a1.svg";
export { ForwardRef as ReactComponent };